module.exports = __webpack_public_path__ + "img/p5.6871f987.png";